import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const CreativeNavMenu = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState("/");

  const menuItems = [
    { name: "Home", path: "/" },
    // { name: "Shop", path: "/" },
    // { name: "About Us", path: "/" },
    { name: "Contact Us", path: "/contactus" },
  ];

  const handleNavigate = (path) => {
    setActive(path);
    navigate(path);
  };

  return (
    <nav className="creative-nav">
      <ul>
        {menuItems.map((item) => (
          <li
            key={item.path}
            className={active === item.path ? "active" : ""}
            onClick={() => handleNavigate(item.path)}
          >
            {item.name}
          </li>
        ))}
      </ul>

      {/* Internal Styling */}
      <style>
        {`
          .creative-nav {
            text-align: center;
            padding: 05px 0;
            {/* background-color: #f8f9fa; */}
            {/* box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1); */}
          }

          .creative-nav ul {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            justify-content: center;
            gap: 10px;
          }

          .creative-nav li {
            padding: 10px 15px;
            cursor: pointer;
            font-weight: bold;
            color: #333;
            position: relative;
            transition: all 0.3s ease;
          }

          .creative-nav li::after {
            content: "";
            display: block;
            height: 2px;
            width: 0%;
            background-color: #136E95;
            transition: width 0.3s ease-in-out;
            position: absolute;
            bottom: -5px;
            left: 0;
          }

          .creative-nav li:hover::after {
            width: 100%;
          }

          .creative-nav li.active {
            color: #136E95;
          }

          .creative-nav li.active::after {
            width: 100%;
          }
        `}
      </style>
    </nav>
  );
};

export default CreativeNavMenu;
